import { analyticsConstants } from "../constants/ActionTypes";
import { baseUrl } from '../constants/baseUrl';

export const getNumOrdersAction = (paramObj, onSuccess, onFailure) => ({
    type: analyticsConstants.GET_NUM_ORDERS,
    payload: paramObj,
    meta: {
        type: 'api',
        url: baseUrl + '/num_orders',
        onSuccess: onSuccess,
        onFailure: onFailure,
        params: {
            shop_id: paramObj.shopId,
            date_first: paramObj.dateFirst,
            date_second: paramObj.dateSecond
        },
        options: {
            method: 'GET'
        }
    }
})

